import Nullstack from 'nullstack';
export default function IconRadar({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-radar",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M21 12h-8a1 1 0 1 0 -1 1v8a9 9 0 0 0 9 -9"
  }), "   ", Nullstack.element("path", {
    d: "M15.999 8.998a5 5 0 1 0 -6.999 7.003"
  }), "   ", Nullstack.element("path", {
    d: "M20.486 8.995a9 9 0 1 0 -11.482 11.495"
  }), " ");
}